export const emptyDraft = ()=>({
        optionIds: [],
        customText: ""
    });
export const isAnswered = (draft)=>Boolean(draft && (draft.optionIds.length > 0 || draft.customText.trim().length > 0));
export const isOverridden = (draft)=>Boolean(draft?.customText.trim());
export const questionsOf = (request)=>request.questions?.length ? request.questions : [
        {
            id: request.toolCallId,
            question: request.title,
            options: request.options,
            freeTextLabel: request.freeTextLabel,
            freeTextPlaceholder: request.freeTextPlaceholder
        }
    ];
export function answersOf(questions, selection) {
    if (!selection) return new Map();
    if (selection.answers?.length) return new Map(selection.answers.map((answer)=>[
            answer.questionId,
            answer
        ]));
    const [first] = questions;
    if (!first || !selection.optionId && !selection.customText) return new Map();
    return new Map([
        [
            first.id,
            {
                questionId: first.id,
                optionIds: selection.optionId ? [
                    selection.optionId
                ] : undefined,
                customText: selection.customText
            }
        ]
    ]);
}
export function answerText(question, answer) {
    const written = answer?.customText?.trim();
    if (written) return `“${written}”`;
    const labels = (answer?.optionIds ?? []).map((optionId)=>question.options.find((option)=>option.id === optionId)?.label ?? optionId);
    return labels.join(", ") || undefined;
}
export function toAnswer(questionId, draft) {
    const customText = draft.customText.trim();
    return customText ? {
        questionId,
        customText
    } : {
        questionId,
        optionIds: draft.optionIds.length > 0 ? draft.optionIds : undefined
    };
}
export const isAtMax = (question, optionIds)=>Boolean(question.multiSelect && question.max && optionIds.length >= question.max);
export function toggledOptionIds(question, current, optionId) {
    if (current.includes(optionId)) return current.filter((id)=>id !== optionId);
    if (!question.multiSelect) return [
        optionId
    ];
    return isAtMax(question, current) ? current : [
        ...current,
        optionId
    ];
}
export const unansweredCount = (questions, drafts)=>questions.filter((question)=>!isAnswered(drafts[question.id])).length;
export function selectionOf(questions, drafts) {
    if (unansweredCount(questions, drafts) > 0) return null;
    return {
        answers: questions.map((question)=>toAnswer(question.id, drafts[question.id]))
    };
}
export function matchesFilter(option, term) {
    const needle = term.trim().toLowerCase();
    return !needle || `${option.label} ${option.description ?? ""}`.toLowerCase().includes(needle);
}
